export const euComplianceBanner = () => {
    (function ($) {
      $(document).ready(function () {
         
        if ($('.eu-cookie-compliance-banner').length) {
            const cookieBanner =$('.eu-cookie-compliance-banner');
            cookieBanner.addClass('eu-cookie-compliance-banner--open');

            $('.decline-button, .agree-button, .close').on('click', function () {
                cookieBanner.removeClass('eu-cookie-compliance-banner--open');
            })
        }
        
      })
    })(jQuery)
}
